<template>
  <rum-select v-bind="$attrs" :value="value" :options="tzOptions" label="label" @input="(e) => $emit('input', e)"></rum-select>
</template>

<script>
import moment from "moment-timezone";
import { computeTimezoneOptions } from "@/utils/timezones";

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      tzOptions: [],
    }
  },
  methods: {
    computeTimezoneOptions() {
      // const moment = moment();
      this.tzOptions = computeTimezoneOptions();
    }
  },
  async mounted() {
    this.computeTimezoneOptions();
    // compute new timezone options every 1 minute
    this.tracker = window.setInterval(this.computeTimezoneOptions, 60000);

    // when a value is not present only then try to guess
    if (!this.value) {
      const guess = this.tzOptions.find(tz => tz.value === moment.tz.guess());
      guess && this.$emit("input", guess);
    }
  },
  destroyed() {
    this.tracker && window.clearInterval(this.tracker);
  }
}
</script>
